import { CardGroup, Card, Container, Col, Row } from 'react-bootstrap';
import * as React from 'react';
export default {
  CardGroup,
  Card,
  Container,
  Col,
  Row,
  React
};